import { Apple, Play } from "lucide-react";
import { trackEvent, EVENTS } from "@/lib/analytics";
import { scrollToId } from "@/lib/scroll";

const StoreButton = ({ icon: Icon, top, bottom, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={() => {
      trackEvent(EVENTS.pricingDownloadCtaClicked, { store: testId });
      scrollToId("launch-notify");
    }}
    className="group relative flex items-center gap-3 rounded-lg border border-white/25 px-5 py-3 text-left transition-colors duration-200 hover:border-white/60"
  >
    <Icon size={26} className="text-white" strokeWidth={1.75} />
    <span>
      <span className="block text-[10px] uppercase tracking-widest text-white/60">{top}</span>
      <span className="block text-sm font-semibold text-white">{bottom}</span>
    </span>
    <span className="absolute -top-2.5 left-4 rounded-sm bg-coacher-red px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-white">
      Coming Soon
    </span>
  </button>
);

const StoreButtons = ({ className = "" }) => (
  <div data-testid="store-buttons" className={`flex flex-wrap items-center gap-4 pt-2 ${className}`}>
    <StoreButton icon={Apple} top="Download on the" bottom="App Store" testId="app-store-coming-soon-button" />
    <StoreButton icon={Play} top="Get it on" bottom="Google Play" testId="google-play-coming-soon-button" />
  </div>
);

export default StoreButtons;
